<template>
  <section class="h-100 my-login-page">
    <div class="container h-100">
      <div class="row justify-content-md-center h-100">
        <div class="card-wrapper">
          <div class="brand">
            <img src="/images/Scout_Logo.png" alt="logo">
          </div>
          <div class="card fat">
            <div class="card-body">
              <h4 class="card-title">Login</h4>
              <form method="POST" class="my-login-validation" novalidate="" @submit.prevent="doLogin">
                <div class="form-group">
                  <input type="text" v-model="fields.login" class="form-control" name="email" value="" placeholder="Login" required autofocus>
                </div>
                <div class="form-group">
                  <input v-model="fields.password" type="password" class="form-control" name="password" placeholder="Password" required  >
                </div>
                <div class="form-group">
                  <input v-model="fields.station" type="text" class="form-control" name="station" placeholder="Station" required  >
                </div>
                <div class="form-group">
                  <select class="form-control" v-model="fields.lang">
                    <option v-for="lang in langs" :value="lang.key">{{ lang.val }}</option>
                  </select>
                </div>
                <div class="form-group m-0">
                  <button type="submit" class="btn btn-primary btn-block">
                    Login
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import api from '@/api';
import qs from 'qs';

export default {
  name: 'login',
  created() {
    localStorage.setItem('uiLang', 'en');
    setDict(window['dict_en']);
    let user = JSON.parse(localStorage.getItem('user'));
    if(user) {
      this.$router.push('/select');
    }
  },
  updated() {
    localStorage.setItem('uiLang', 'en');
    setDict(window['dict_en']);
  },
  data () {
    return {
      fields: {
        login: '',
        password: '',
        station: '',
        lang: 'he',
      },
      langs: [
        {key: 'he', val: 'Hebrew'},
        {key: 'en', val: 'English'},
      ]
    }
  },
  methods: {
    doLogin() {
      this.errType = null;
      api.post('/auth/index/loginer', qs.stringify(this.fields) )
      .then(result => {
        if(!result.data.success) {
          notie.alert({ type: 'error', text: result.data.error });
          return false;
        }
        let setLang = this.fields.lang;
        if (!result.data.langs.includes(setLang)) {
          setLang = result.data.langs[0];
        }
        //localStorage.setItem('aToken', result.data.token);

        localStorage.setItem('user', JSON.stringify(result.data.user) );
        localStorage.setItem('uiLang', setLang);

        this.$store.commit('LOGIN_USER');
        this.$store.commit('UPDATE_USER_INFO', result.data.user);

        this.$socket.client.open();

        localStorage.removeItem('callStatus');
        localStorage.removeItem('phoneId');

        window.setDict(window['dict_'+setLang]);
        this.$router.push('/select');
      }).catch(err => {
        let message;
        notie.alert({ type: 'error', text: err.response.data.message });
      })
    }
  }
};
</script>
